<template>
  <div class="p-fluid p-formgrid p-grid">    

    <!-- <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Refeição</h6>
      <div class="p-field-radiobutton">
        <RadioButton id="parametroRefeicao1" name="parametroRefeicao" v-model.number="politicaContratual.parametroRefeicao" :value="2"/>
        <label>Marcação inexistente</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="parametroRefeicao2" name="parametroRefeicao" v-model.number="politicaContratual.parametroRefeicao" :value="3"/>
        <label>Marcação pré-assinalada</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="parametroRefeicao3" name="parametroRefeicao" v-model.number="politicaContratual.parametroRefeicao" :value="4"/>
        <label>Marcação flexível</label>
      </div>
    </div>     -->

    <!-- <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Lanche</h6>
      <div class="p-field-checkbox">
        <Checkbox v-model="politicaContratual.descontarSegundoIntervalo" :binary="true"/>
        <label>Descontar o segundo intervalo</label>
      </div>
    </div> -->

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Adicional noturno <span class="campo-obrigatorio">*</span></h6>
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>De</label>
          <InputText v-model="politicaContratual.horaAdicionalNoturnoDe" maxlength="5" placeholder=":" class="p-text-center" 
            @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('horaAdicionalNoturnoDe')"/>
        </div>
        <div class="p-field p-col-2 p-md-2">
          <label>Até</label>
          <InputText v-model="politicaContratual.horaAdicionalNoturnaAte" maxlength="5" placeholder=":" class="p-text-center" 
            @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('horaAdicionalNoturnaAte')"/>
        </div>
      </div> 
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>Valor da hora</label>
          <InputText v-model.number="politicaContratual.duracaoHoraNoturna" maxlength="5" class="p-text-center" @keyup="formatarEtrada"/>        
        </div>
        <div class="p-field-checkbox p-pl-2">
          <Checkbox v-model="politicaContratual.descontarIntervalosNoturno" :binary="true"/>
        <label>Descontar intervalos</label>
        </div>
      </div>      
    </div> 

   
    <div class="p-field p-col-12 p-md-12">  
      <h6 class="p-text-bold">Faixas horárias <span class="campo-obrigatorio">*</span></h6>    
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>Horas D.S.R</label>
          <InputText v-model="politicaContratual.horasDSR" maxlength="5" placeholder=":" class="p-text-center" 
            @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('horasDSR')"/>
        </div>
        <div class="p-field p-col-2 p-md-2">
          <label>Horas mensalitas</label>
          <InputText type="number" v-model="politicaContratual.horasMensaisalistas" class="p-text-center" min="0"/>
        </div>
      </div>           
    </div> 
  

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Controle de faltas </h6>
      <div class="p-field-radiobutton">
          <RadioButton id="controleFalta1" name="controleFalta" v-model.number="politicaContratual.controleFalta" :value="1"/>
          <label>Horas legais</label>
      </div>
      <div class="p-field-radiobutton">
          <RadioButton id="controleFalta2" name="controleFalta" v-model.number="politicaContratual.controleFalta" :value="2"/>
          <label>Horas trabalhadas</label>
      </div>           
    </div> 

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Interjornada <span class="campo-obrigatorio">*</span></h6>
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label for="firstname">Horas</label>
          <InputText v-model="politicaContratual.tempoInterjornada" maxlength="5" placeholder=":" class="p-text-center" 
            @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('tempoInterjornada')"/>
        </div>        
      </div>           
    </div>   

  </div>
</template>

<script>
import PoliticaContratual from '@/model/PoliticaContratual';
import { formatarEtradaFloat, formatarEtradaHora } from '@/global';

export default {  
  data() {
    return {
      politicaContratual: new PoliticaContratual(),
    }   
  },
  methods: {
    setConfiguracao(politicaContratual) {
      this.politicaContratual = politicaContratual;
    },
    getConfiguracao() {
      if(this.politicaContratual.horaAdicionalNoturnoDe == '' || this.politicaContratual.horaAdicionalNoturnaAte == ''
        || this.politicaContratual.duracaoHoraNoturna == '' || this.politicaContratual.horasDSR == ''
        || this.politicaContratual.horasMensaisalistas == 0 || this.politicaContratual.tempoInterjornada == '') {
        throw 'Contratual: Informe os campos obrigatórios'
      } else {
        return {...this.politicaContratual}
      }
    },
    limparEntradaHoraInvalida(campo) {
      if(this.politicaContratual[campo] == null) {
        return;
      }
      let regex = /[0-2][0-9]:[0-5][0-9]/g;
      if(!this.politicaContratual[campo].match(regex)) {
        this.politicaContratual[campo] = '';
      }
    },
    validarEntraHora(event) {
      formatarEtradaHora(event);
    },
    formatarEtrada(event) {
      formatarEtradaFloat(event);
    }
  },
  created() {
    this.politicaContratual.parametroRefeicao = 4;
    this.politicaContratual.horasDSR = '07:33';
    this.politicaContratual.horaAdicionalNoturnoDe = '22:00';
    this.politicaContratual.horaAdicionalNoturnaAte = '05:00';
    this.politicaContratual.duracaoHoraNoturna = 52.50;
    this.politicaContratual.tempoInterjornada = '11:00';
    this.politicaContratual.horasMensaisalistas = 220;
    this.politicaContratual.controleFalta = 2;
  }

}
</script>

<style>

</style>